import * as React from "react";
import {getSingers} from "../http/singerApi";
import {getReportData, createReport} from "../http/reportApi";
import PeriodChooser from "../components/PeriodChooser";
import Box from "@mui/material/Box";
import SingersAdder from "../components/SingersAdder";
import Typography from "@mui/material/Typography";
import FormControl from "@mui/material/FormControl";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import {useNavigate, useParams} from "react-router-dom";
import {LOGIN_ROUTE} from "../utils/constants";
import {observer} from "mobx-react-lite";
import {Context} from "../index";
import {DataGrid} from "@mui/x-data-grid";

const Report = observer(() => {
    const colModel = {
        field: "",
        headerName: "",
        width: 200,
        editable: false,
        description: "",
        sortable: true,
    };

    const smallDigits = (val)=>{
        if(val){
            return (parseInt(val * 100) / 100);
        }

        return 0;
    }

    const [columns, setColumns] = React.useState([
        {
            ...colModel,
            field: "provider",
            headerName: "Контент-Провайдер",
            description: "Контент-Провайдер",
        },
        {
            ...colModel,
            field: "period",
            headerName: "Период",
            description: "Период",
        },
        {
            ...colModel,
            field: "songName",
            headerName: "Трек",
            description: "Трек",
        },
        {
            ...colModel,
            field: "singer",
            headerName: "Исполнитель",
            description: "Исполнитель",
        },
        {
            ...colModel,
            field: "platform",
            headerName: "Тип контента",
            description: "Тип контента",
        },
        {
            ...colModel,
            field: "downloads",
            headerName: "Количество скачиваний",
            description: "Количество скачиваний",
        },
        {
            ...colModel,
            field: "relatedContentCost",
            headerName: "Ст-ть ед. контента смежные",
            description: "Ст-ть ед. контента смежные",
        },
        {
            ...colModel,
            field: "authorContentCost",
            headerName: "Ст-ть ед. контента авторские",
            description: "Ст-ть ед. контента авторские",
        },
        {
            ...colModel,
            field: "relatedLicensePrize",
            headerName: "Вознаграждение Лицензиара смежные",
            description: "Вознаграждение Лицензиара смежные",
        },
        {
            ...colModel,
            field: "authorLicensePrize",
            headerName: "Вознаграждение Лицензиара авторские",
            description: "Вознаграждение Лицензиара авторские",
        },
    ]);
    const [data, setData] = React.useState([]);
    const [reportInfo, setReportInfo] = React.useState({});
    const {user} = React.useContext(Context);
    let {report} = useParams();

    const navigate = useNavigate();

    const getReport = async (reportId) => {
        try {
            const response = await getReportData(reportId);
            console.log(response);
            setReportInfo(response);
            setData(response.rows);
        } catch (error) {
            if (error.response.status === 401) {
                localStorage.clear();
                user.setIsAuth(false);
                return navigate(LOGIN_ROUTE);
            }
        }
    };

    const downloadReport = async () => {
        try {
            const response = await createReport(report);
            console.log(response);
            console.log(report);
            let contentType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
            var a = document.createElement('a');
            var blob = new Blob([response.data], {'type':contentType});
            a.href = window.URL.createObjectURL(response.data);
            a.download = report + "_report_" + (new Date().valueOf()) + ".xlsx";
            a.click();
        } catch (error) {
            if (error.response && error.response.status === 401) {
                localStorage.clear();
                user.setIsAuth(false);
                return navigate(LOGIN_ROUTE);
            }
        }
    }

    React.useEffect(() => {
        // document.title = "Report";
        getReport(report);
    }, [report]);

    let totals = [];
    if (reportInfo.calculated?.summary) {
        let {related, copyright, taxFee} = reportInfo.calculated;
        totals.push(<tr key={'tbl_title'}>
            <td></td>
            <td>Смежные права:</td>
            <td>Авторские права:</td>
        </tr>);
        totals.push(<tr key={'tbl_charge'}>
            <td>Прибыль:</td>
            <td>{smallDigits(related.charge)}</td>
            <td>{smallDigits(copyright.charge)}</td>
        </tr>);
        totals.push(<tr key={'tbl_tax'}>
            <td>Tax fee ({taxFee}):</td>
            <td>{related.taxFee}</td>
            <td>{copyright.taxFee}</td>
        </tr>);
        totals.push(<tr key={'tbl_tospent'}>
            <td>Вычет:</td>
            <td>{smallDigits(related.toSpent)}</td>
            <td>{smallDigits(copyright.toSpent)}</td>
        </tr>);
        totals.push(<tr key={'tbl_licperc'}>
            <td>Доля лицензиаров:</td>
            <td>{related.licensiarsPercent ? `${related.licensiarsPercent}%` : ''}</td>
            <td>{copyright.licensiarsPercent ? `${copyright.licensiarsPercent}%` : ''}</td>
        </tr>);
        totals.push(<tr key={'tbl_licpart'}>
            <td>Вознаграждение лицензиаров:</td>
            <td>{smallDigits(related.licensiarsPart)}</td>
            <td>{smallDigits(copyright.licensiarsPart)}</td>
        </tr>);
        totals.push(<tr key={'tbl_singperc'}>
            <td>Доля лицензиара:</td>
            <td>{related.singerPercent ? `${related.singerPercent}%` : ''}</td>
            <td>{copyright.singerPercent ? `${copyright.singerPercent}%` : ''}</td>
        </tr>);
        totals.push(<tr key={'tbl_singpart'}>
            <td>Вознаграждение лицензиара:</td>
            <td>{smallDigits(related.singerPart)}</td>
            <td>{smallDigits(copyright.singerPart)}</td>
        </tr>);
        totals.push(<tr key={'tbl_vat'}>
            <td>Налог:</td>
            <td>{related.vat ? `${parseInt(related.vatNum)}(${related.vat}%)` : ''}</td>
            <td>{copyright.vat ? `${parseInt(copyright.vatNum)}(${copyright.vat}%)` : ''}</td>
        </tr>);
        totals.push(<tr key={'tbl_summ'}>
            <td>Итого к выплате:</td>
            <td></td>
            <td>{smallDigits(reportInfo.calculated?.summary)}</td>
        </tr>);
    }

    return (
        <div
            style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexDirection: "column",
                marginTop: 20,
            }}
        >
            <Typography variant={'h5'}>Отчет</Typography>
            <div
                style={{
                    width: "100%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "flex-end",
                    flexDirection: "row",
                    marginBottom: 20,
                    marginRight: 20
                }}
            >
                <Button
                    type={'button'}
                    onClick={downloadReport}
                    variant="contained"
                    color="info"
                >Скачать XLSX</Button>
            </div>
            {data && columns && (
                <Box sx={{height: "100%", width: "100%"}}>
                    <DataGrid
                        rows={data}
                        columns={columns}
                        initialState={{
                            pagination: {
                                paginationModel: {
                                    pageSize: 100,
                                },
                            },
                        }}
                        pageSizeOptions={[10, 20, 50, 100]}
                        disableRowSelectionOnClick
                    />
                </Box>
            )}
            <Box
                sx={{width: "100%"}}
                display="flex"
                flexDirection="row"
                justifyContent="flex-end"
                alignItems="flex-start"
                p={2}
            >
                <table className={'total_output'} key={'total_output'}>
                    <tbody>
                    {totals.map((row) => (row))}
                    </tbody>
                </table>
            </Box>
        </div>
    );
});

export default Report;
